<template>
	<div style="width:90%">
		<div class="container_body">
			<header class="header_nav">
				<el-form :inline="true" class="demo-form-inline" :model="searchInfo" style="margin: 20px 0px 0px 20px;">
					<el-form-item label="用户ID" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.userId" placeholder="请输入用户ID"></el-input>
					</el-form-item>
					<el-form-item label="用户账号" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.username" placeholder="请输入账号"></el-input>
					</el-form-item>
					<el-form-item label="手机号" class='tiny'>
						<el-input style="width: 200px;" v-model="searchInfo.phone" placeholder="请输入手机号"></el-input>
					</el-form-item>

					<el-form-item>
						<template>
							<el-button type="primary" @click="search">查询</el-button>
							<el-button @click="empty">清空</el-button>
						</template>
					</el-form-item>
				</el-form>
			</header>
		</div>


		<el-table :data="userList.list" stripe style="width: 100%;" :header-cell-style="headClass"
			v-loading="tableLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">

			<el-table-column prop="id" label="用户" sortable align="center" width="300">
				<template slot-scope="scope">
					{{scope.row.userId}}~{{scope.row.username}}~{{scope.row.phone}}
				</template>
			</el-table-column>


			<el-table-column prop="phone" label="总贡献" align="center" :show-overflow-tooltip="true"
				:formatter="changeNull">
				<template slot-scope="scope">
					{{Math.floor(scope.row.activateCount+scope.row.teamCount+scope.row.inviterCount+scope.row.storeCount)+
					
			
					Math.floor(scope.row.shopAmount+scope.row.teamShopAmount)+
					Math.floor(scope.row.calculate)+
					Math.floor(scope.row.confirmationRightsCount)}}
				</template>
			</el-table-column>
			<el-table-column prop="inviterCount" label="链接贡献" align="center" :show-overflow-tooltip="true"
				:formatter="changeNull">
				<template slot-scope="scope">
					{{Math.floor(scope.row.activateCount+scope.row.teamCount+scope.row.inviterCount+scope.row.storeCount)}}
				</template>
			</el-table-column>
			<el-table-column prop="teamShopAmount" label="消费贡献" align="center" :show-overflow-tooltip="true"
				:formatter="changeNull">
				<template slot-scope="scope">
					{{Math.floor(scope.row.teamShopAmount+scope.row.shopAmount)}}
				</template>
			</el-table-column>
			<el-table-column prop="calculate" label="活跃贡献" align="center" width="100" :show-overflow-tooltip="true"
				:formatter="changeNull">
				<template slot-scope="scope">
					{{Math.floor(scope.row.calculate)}}
				</template>
			</el-table-column>
			<el-table-column label="积分确权" prop="confirmationRightsCount" align="center" width="100">

			</el-table-column>

			<el-table-column label="操作" fixed="right" align="center">
				<template slot-scope="scope">
					<el-button type="text" @click.native="datails(scope.row)" size="small">查看详情</el-button>
					<el-dropdown trigger="click" style="margin-left: 10px;">
						<el-button type="text" size="small">更多</el-button>
						<el-icon class="el-icon-caret-bottom"></el-icon>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item @click.native="toShowProperty(scope.row.id)">查看资产</el-dropdown-item>
							<el-dropdown-item @click.native="toShowInvite(scope.row.id)">邀请关系</el-dropdown-item>
							<el-dropdown-item @click.native="wangti(scope.row.id)">网体归属</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
					　　　　
				</template>
			</el-table-column>
		</el-table>
		<!-- :current-page="userList.pageNum" -->
		<el-pagination style="margin: 20px 0px 20px 0px ;" background :current-page="1" @current-change="pageChange"
			:page-sizes="[10, 20, 50, 100, 150, 200,300,400,500]" layout="total, sizes, prev, pager, next, jumper"
			:total="userList.total" @size-change="handleSizeChange">
		</el-pagination>



		<!-- 邀请下级 -->
		<el-dialog style="float:rigin" title="邀请下级" :visible.sync="inviteDialogVisible" width="80%"
			:close-on-click-modal="false">
			<el-table :data="inviteData.list" stripe style="width: 100%;" :header-cell-style="headClass" height="400"
				v-loading="inviteDataLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
				row-key="id" lazy :load="dialogTableLoad"
				:tree-props="{children: 'children', hasChildren: 'hasChildren'}">
				<el-table-column prop="id" label="UID" align="center" :show-overflow-tooltip="true"
					:formatter="changeNull">
				</el-table-column>
				<el-table-column prop="username" label="账号" align="center" :show-overflow-tooltip="true"
					:formatter="changeNull">
				</el-table-column>
				<el-table-column prop="nickname" label="昵称" align="center" :show-overflow-tooltip="true"
					:formatter="changeNull">
				</el-table-column>
				<el-table-column prop="" label="商家" align="center" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<p v-if="scope.row.isStore==true">
							<span v-if="scope.row.storeType==0">线上</span>
							<span v-if="scope.row.storeType==1">门店</span>
						</p>
						<p v-else>未开通</p>
					</template>
				</el-table-column>
				<el-table-column prop="agentLevel" label="服务商" align="center" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<p v-if="scope.row.agentLevel==0">否</p>
						<p v-if="scope.row.agentLevel==1">省级</p>
						<p v-if="scope.row.agentLevel==2">市级</p>
						<p v-if="scope.row.agentLevel==3">区县</p>
					</template>
				</el-table-column>
				<el-table-column prop="total" label="DWQ余额" align="center" :show-overflow-tooltip="true"
					:formatter="changeNull">
				</el-table-column>
				<el-table-column prop="inviterCount" label="邀请人数" align="center" :show-overflow-tooltip="true"
					:formatter="changeNull">
				</el-table-column>
				<el-table-column prop="teamCount" label="团队人数" align="center" :show-overflow-tooltip="true"
					:formatter="changeNull">
				</el-table-column>
				<el-table-column prop="shopMiningSelf" label="本人消费" align="center" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="shopMiningTeam" label="团队消费" align="center" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="teamCount" label="流量池" align="center" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<span>{{ scope.row.flowValid?scope.row.flowValid:'0' }}
							(储备积分:{{ scope.row.flowLock?scope.row.flowLock:'0' }})</span>
					</template>

				</el-table-column>
				<el-table-column prop="lastActivityDate" label="登录" align="center" :show-overflow-tooltip="true">
				</el-table-column>
			</el-table>
			<el-pagination style="margin: 20px;" background :current-page="inviteData.pageNum"
				@current-change="pageInviteChange" :page-sizes="[10, 20, 50, 100, 150, 200]"
				layout="total, sizes, prev, pager,next" :total="inviteData.total" @size-change="handleInviteSizeChange">
			</el-pagination>
			<div style="text-align: center;">
				<el-button @click="inviteDialogVisible = false">返回</el-button>
			</div>
		</el-dialog>

		<!-- 查看资产 -->
		<el-dialog style="float: rigin" title="用户资产" :visible.sync="propertyDialogVisible" width="60%" append-to-body
			:close-on-click-modal="false">
			<el-table :data="userPropertyList.list" stripe style="width: 100%;" :header-cell-style="headClass"
				v-loading="loadingUserProperty" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading">
				<el-table-column prop="username" label="用户账号" align="center" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="nickname" label="用户昵称" align="center" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="phone" label="手机号" align="center" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="introduce" label="资产名称" align="center" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="inUseCnt" label="可用" align="center">
					<template slot-scope="scope">
						<span> {{scope.row.inUseCnt}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="lockCnt" label="冻结" align="center">
					<template slot-scope="scope">
						<span> {{scope.row.lockCnt}}</span>
					</template>
				</el-table-column>

			</el-table>
		</el-dialog>

		<!-- 网体归属 -->
		<el-dialog style="float:rigin" title="网体归属" :visible.sync="wtDialogVisible" width="80%"
			:close-on-click-modal="false">
			<el-table :data="twData.list" stripe style="width: 100%;" :header-cell-style="headClass"
				v-loading="loadingTwo" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
				height="550" row-key="id" :tree-props="{ hasChildren: 'hasChildren', children: 'children' }">

				<!-- <el-table :data="twData.list" stripe style="width: 100%;" :header-cell-style="headClass" height="400"
				v-loading="loadingTwo" element-loading-text="拼命加载中" 
				element-loading-spinner="el-icon-loading" row-key="id"  lazy :load="load"
				:tree-props="{children: 'children', hasChildren: 'hasChildren'}"> -->
				<el-table-column prop="id" label="UID" align="center" :show-overflow-tooltip="true"
					:formatter="changeNull">
				</el-table-column>
				<el-table-column prop="username" label="账号" align="center" :show-overflow-tooltip="true"
					:formatter="changeNull">
				</el-table-column>
				<el-table-column prop="nickname" label="昵称" align="center" :show-overflow-tooltip="true"
					:formatter="changeNull">
				</el-table-column>
				<el-table-column prop="" label="商家" align="center" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<p v-if="scope.row.isStore==true">
							<span v-if="scope.row.storeType==0">线上</span>
							<span v-if="scope.row.storeType==1">门店</span>
						</p>
						<p v-else>未开通</p>
					</template>
				</el-table-column>
				<el-table-column prop="agentLevel" label="服务商" align="center" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<p v-if="scope.row.agentLevel==0">否</p>
						<p v-if="scope.row.agentLevel==1">省级</p>
						<p v-if="scope.row.agentLevel==2">市级</p>
						<p v-if="scope.row.agentLevel==3">区县</p>
					</template>
				</el-table-column>
				<el-table-column prop="total" label="DWQ余额" align="center" :show-overflow-tooltip="true"
					:formatter="changeNull">
				</el-table-column>
				<el-table-column prop="inviterCount" label="邀请人数" align="center" :show-overflow-tooltip="true"
					:formatter="changeNull">
				</el-table-column>
				<el-table-column prop="teamCount" label="团队人数" align="center" :show-overflow-tooltip="true"
					:formatter="changeNull">
				</el-table-column>
				<el-table-column prop="shopMiningSelf" label="本人消费" align="center" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="shopMiningTeam" label="团队消费" align="center" :show-overflow-tooltip="true">
				</el-table-column>
				<el-table-column prop="teamCount" label="流量池" align="center" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<span>{{ scope.row.flowValid?scope.row.flowValid:'0' }}
							(储备积分:{{ scope.row.flowLock?scope.row.flowLock:'0' }})</span>
					</template>

				</el-table-column>
				<el-table-column prop="lastActivityDate" label="登录" align="center" :show-overflow-tooltip="true">
				</el-table-column>
			</el-table>

			<el-pagination background :current-page="twData.pageNum" @current-change="pageWgChange"
				layout="total, sizes, prev, pager,next" :total="twData.total" @size-change="handleWgSizeChange">
			</el-pagination>
			<span slot="footer" class="dialog-footer">
				<el-button @click="wtDialogVisible = false">返回</el-button>
			</span>
		</el-dialog>
		<el-dialog style="float:rigin" title="详情" :visible.sync="xqDialogVisible" width="30%"
			:close-on-click-modal="false">
			<div style="background: #f3f3f3;padding: 10px">
				<div style="padding: 10px 0;font-size: 14px;font-weight: 500;">
					会员{{qqid}}~{{userName}}~{{userphone}}
				</div>
				<div style="padding: 10px 0;font-size: 16px;font-weight: 700;">
					总贡献{{zsum}}
				</div>
				<div>
					<div class="" style="margin: 10px 20px;border-radius: 20px;background: white;">
						<div class="" style="display: flex;flex-direction: row;padding:  10px;">
							<span style="color: #444446;">链接贡献</span>
							<span style=";padding-left: 20px;" class="textss">{{gxsum|fixedTwo}}</span>
						</div>
					
						<div class="" style="height: 2px;width: 100%;background: rgb(215, 215, 215);">
				
						</div>
						<div class="showData" style="">
							<div class="" style="padding: 10px 20px;line-height: 30px;">
				
								<div class=""
									style="font-size: 26upx;display: flex;flex-direction: row;align-items: center;">
									<img src="../../assets/img/hyy.png" style="width: 20px;height: 20px;margin-right: 10px;" mode=""></img>	邀请
									<span style="color: red;">{{sData.inviterCount|fixedTwo}}</span>
									位好友<div style="width: 40px;"></div>
									<span class="texts">{{sData.inviterCount*gxInfo.inviterRatio|fixedTwo}}</span>
				
								</div>
								<div class="" style=";display: flex;flex-direction: row;align-items: center;">
									<img src="../../assets/img/xff.png" style="width: 20px;height: 20px;margin-right: 10px;" mode=""></img>
									产生消费的
									<span style="color: red;">{{sData.activateCount}}</span>
									位好友<div style="width: 40px;"></div>
				
									{{sData.activateCount*gxInfo.activateRatio|fixedTwo}}
				
								</div>
								<div class="" style=";display: flex;flex-direction: row;align-items: center;">
									<img src="../../assets/img/sq.png" style="width: 20px;height: 20px;margin-right: 10px;" mode=""></img>
									社区
									<span style="color: red;">{{sData.teamCount}}</span>
									好友<div style="width: 40px;"></div>
									<span class="texts">
										{{sData.teamCount*gxInfo.teamRatio|fixedTwo}}
									</span>
								</div>
								<div class="" style="display: flex;flex-direction: row;align-items: center;justify-content: space-between;">
									<div style=";display: flex;">	
										<img src="../../assets/img/sh.png" style="width: 20px;height: 20px;margin-right: 10px;" mode=""></img>
										链接
										<span style="color: red;">{{sjsums|fixedTwo}}</span>
										位商户 <div style="width: 40px;"></div>
										<span class="texts">
											{{sjsum|fixedTwo}}
										</span>
									</div>
									<div style="text-decoration: underline;" @click="storeti">
										查看经营概况
									</div>   
									<!-- <div class="" @click="gostoreList" v-if="sjsum>0"
											style="flex: 1;text-align: right;padding-right: 20rpx;text-decoration: underline;">
											查看商户经营概况
										</div> -->
								</div>
				
							</div>
				
						</div>
					</div>
				
					<div class="" style="margin: 10px 20px;border-radius: 20px;background: white;">
						<div class="" style="display: flex;flex-direction: row;padding:  10px;">
							<span style="color: #444446;">消费贡献</span>
							<span style="padding-left: 20px;" class="textss">{{xfsum|fixedTwo}}</span>
						</div>
						<div class="" style="height: 2px;width: 100%;background: rgb(215, 215, 215);">
				
						</div>
						<div class="showData" style="">
							<div class="" style="padding: 10px 20px;line-height: 30px;;">
				
								<div class="" style=";display: flex;flex-direction: row;align-items: center;">
									<img src="../../assets/img/wdxf.png" style="width: 20px;height: 20px;margin-right: 10px;" mode=""></img>
									我的消费 <span style="color: red;">￥{{sData.shopAmount}}</span>
									<div style="width: 40px;"></div>
									<span class="texts">{{sData.shopAmount*gxInfo.shopAmountRatio|fixedTwo}}</span>
				
				
									<!-- <div @click="goorder" class=""
											style="flex: 1;text-align: right;padding-right: 20rpx;text-decoration: underline;">
											查看订单记录
										</div> -->
								</div>
								<div class=""
									style="font-size: 26upx;display: flex;flex-direction: row;align-items: center;">
									<img src="../../assets/img/sqxf.png" style="width: 20px;height: 20px;margin-right: 10px;" mode=""></img>
									社区消费 <span style=";color: red;">￥{{sData.teamShopAmount}}</span>
									<div style="width: 40px;"></div>
									<span class="texts">
										{{sData.teamShopAmount*gxInfo.teamShopAmountRatio|fixedTwo}}
									</span>
								</div>
							</div>
				
						</div>
					</div>
				
					<div class="" style="margin: 10px 20px;border-radius: 20px;background: white;">
						<div class="" style="display: flex;flex-direction: row;padding:  10px;">
							<span style="color: #444446;">活跃贡献</span>
							<span style="padding-left: 20px;"
								class="textss">{{sData.calculate*gxInfo.calculateRatio | fixedTwo}}</span>
						</div>
						<div class="" style="height: 2px;width: 100%;background: rgb(215, 215, 215);">
				
						</div>
						<div class="showData">
							<div class="" style="padding: 10px 20px;line-height: 30px;;">
				
								<div class="" style="display: flex;flex-direction: row;align-items: center;">
									<img src="../../assets/img/hygx.png" style="width: 20px;height: 20px;margin-right: 10px;" mode=""></img>
									活跃值 <div style="width: 40px;"></div><span class="texts">
										{{sData.calculate|fixedTwo}}</span>
				
								</div>
				
				
							</div>
				
						</div>
					</div>
				
					<div class="" style="margin: 10px 20px;border-radius: 20px;background: white;">
						<div class="" style="border-radius: 20px;background: white;padding:  10px;">
							<div class="" style="display: flex;flex-direction: row;justify-content: space-between;">
								<div class="" style="display: flex;flex-direction: row">
									<span style="fcolor: #444446;">积分确权</span>
									<span style="padding-left: 20px;" class="textss">{{qqsum|fixedTwo}}</span>
								</div>
								<div style="text-decoration: underline;" @click="qqti">
									查看记录
								</div>
							</div>
						</div>
						<div class="" style="height: 2px;width: 100%;background: rgb(215, 215, 215);">
				
						</div>
						<div class="showData">
							<div class="" style="padding: 10px 20px;line-height: 30px;;">
				
								<div class="" v-for="item in integralList"
									style="font-size: 26upx;display: flex;flex-direction: row;align-items: center;">
									<img :src="item.icon" mode="" style="width: 20px;height: 20px;margin-right: 10px;">
									</img>
									{{item.name}} <span style="color: #7f7f7f;"> (余额：{{item.total}}个)</span>
									<span class="texts" style="padding-left: 40px;">{{item.sum|fixedTwo}}</span>
								</div>
				
							</div>
				
						</div>
					</div>
				
				</div>
			</div>
		</el-dialog>
		<!-- 确权记录 -->
		<el-dialog style="float:rigin" title="确权记录" :visible.sync="qqDialogVisible" width="80%"
			:close-on-click-modal="false">
			<el-table :data="qqData.list" stripe style="width: 100%;" :header-cell-style="headClass"
				v-loading="loadingqq" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
				height="550" row-key="id" :tree-props="{ hasChildren: 'hasChildren', children: 'children' }">
		
				<!-- <el-table :data="twData.list" stripe style="width: 100%;" :header-cell-style="headClass" height="400"
				v-loading="loadingTwo" element-loading-text="拼命加载中" 
				element-loading-spinner="el-icon-loading" row-key="id"  lazy :load="load"
				:tree-props="{children: 'children', hasChildren: 'hasChildren'}"> -->
				<el-table-column prop="userId" label="用户ID" align="center" width="150" :show-overflow-tooltip="true"
					:formatter="changeNull">
				</el-table-column>
				<el-table-column prop="username" label="账号" align="center" width="150" :show-overflow-tooltip="true"
					:formatter="changeNull">
				</el-table-column>
				<!-- <el-table-column prop="nickname" label="昵称" align="center" width="150" :show-overflow-tooltip="true"
					:formatter="changeNull">
				</el-table-column> -->
				
				<el-table-column prop="integralName" label="资产名称" align="center" width="100" :formatter="changeNull">
				</el-table-column>
				<el-table-column prop="confirmationRatio" label="确权比例(%)" align="center" width="150" :formatter="changeNull">
					<template slot-scope="scope">
						{{scope.row.confirmationRatio*100}}
						
					</template>
				</el-table-column>
				<el-table-column prop="total" label="确权数量" align="center" width="150" :formatter="changeNull">
				</el-table-column>
				<el-table-column prop="contributionTotal" label="获得贡献" align="center" width="150" :formatter="changeNull">
				</el-table-column>
				
				<el-table-column label="状态" prop="status" align="center" width="100" >
					<template slot-scope="scope">
						<p v-if="scope.row.status==1">确权中</p>
						
					</template>
				</el-table-column>
				
				<el-table-column prop="changeReason" label="备注" align="center" :formatter="changeNull" :show-overflow-tooltip="true">
				</el-table-column>
						
				<el-table-column prop="createTime" label="创建时间" width="" align="center" :show-overflow-tooltip="true" >
				</el-table-column>
			</el-table>
		
			<el-pagination background :current-page="qqData.pageNum" @current-change="pageWgChangeqq"
				layout="total, sizes, prev, pager,next" :total="qqData.total" @size-change="handleWgSizeChangeqq">
			</el-pagination>
			<span slot="footer" class="dialog-footer">
				<el-button @click="qqDialogVisible = false">返回</el-button>
			</span>
		</el-dialog>
		<!-- 商家列表 -->
		<el-dialog style="float:rigin" title="经营商家" :visible.sync="storeDialogVisible" width="80%"
			:close-on-click-modal="false">
			<el-table :data="storeData.list" stripe style="width: 100%;" :header-cell-style="headClass"
				v-loading="loadingstore" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
				height="550" row-key="id" :tree-props="{ hasChildren: 'hasChildren', children: 'children' }">
		
				<!-- <el-table :data="twData.list" stripe style="width: 100%;" :header-cell-style="headClass" height="400"
				v-loading="loadingTwo" element-loading-text="拼命加载中" 
				element-loading-spinner="el-icon-loading" row-key="id"  lazy :load="load"
				:tree-props="{children: 'children', hasChildren: 'hasChildren'}"> -->
				<el-table-column prop="storeName" label="商家名称" align="center" width="150" :show-overflow-tooltip="true"
					:formatter="changeNull">
				</el-table-column>
				<el-table-column prop="storeLogo" label="店铺LOGO" width="100"  align="center" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<img :src="scope.row.storeLogo" style="width: 60px;height: 60px;border-radius: 10px;" />
					</template>
				</el-table-column>
				
				<el-table-column prop="confirmationRatio" label="级别" align="center" width="80" :formatter="changeNull">
					<template slot-scope="scope">
						Lv{{scope.row.levelType}}
						
					</template>
				</el-table-column>
				<el-table-column prop="confirmationRatio" label="贡献" align="center" width="120" :formatter="changeNull">
					<template slot-scope="scope">
						{{sums(scope.row)}}
						
					</template>
				</el-table-column>
				<el-table-column prop="address" label="地址" align="center" width="300" :formatter="changeNull">
				</el-table-column>
				<el-table-column prop="phone" label="电话" align="center" width="150" :formatter="changeNull">
				</el-table-column>
				<el-table-column prop="businessHours" label="经营时间" align="center" width="150" :formatter="changeNull">
				</el-table-column>
				<el-table-column prop="storeIntro" label="简介" align="center" width="150" :formatter="changeNull">
				</el-table-column>
				
			</el-table>
		
			<el-pagination background :current-page="storeData.pageNum" @current-change="pageWgChangestore"
				layout="total, sizes, prev, pager,next" :total="storeData.total" @size-change="handleWgSizeChangestore">
			</el-pagination>
			<span slot="footer" class="dialog-footer">
				<el-button @click="storeDialogVisible = false">返回</el-button>
			</span>
		</el-dialog>
		<el-dialog style="float:rigin" title="订单" :visible.sync="orderDialogVisible" width="80%"
			:close-on-click-modal="false">
			<el-table :data="orderData.list" stripe style="width: 100%;" :header-cell-style="headClass"
				v-loading="loadingorder" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
				height="550" row-key="id" :tree-props="{ hasChildren: 'hasChildren', children: 'children' }">
		
				<!-- <el-table :data="twData.list" stripe style="width: 100%;" :header-cell-style="headClass" height="400"
				v-loading="loadingTwo" element-loading-text="拼命加载中" 
				element-loading-spinner="el-icon-loading" row-key="id"  lazy :load="load"
				:tree-props="{children: 'children', hasChildren: 'hasChildren'}"> -->
				<el-table-column prop="storeName" label="商家名称" align="center" width="150" :show-overflow-tooltip="true"
					:formatter="changeNull">
				</el-table-column>
				<el-table-column prop="storeLogo" label="店铺LOGO" align="center" :show-overflow-tooltip="true">
					<template slot-scope="scope">
						<img :src="scope.row.storeLogo" style="width: 60px;height: 60px;border-radius: 10px;" />
					</template>
				</el-table-column>
				
				<el-table-column prop="orderCode" label="订单号" align="center" width="150" :formatter="changeNull">
					
				</el-table-column>
				<el-table-column prop="status" label="状态" align="center" width="150" :formatter="changeNull">
					<template slot-scope="scope">
						<p v-if="scope.row.status==0">待付款</p>
						<p v-if="scope.row.status==1">待发货</p>
						<p v-if="scope.row.status==2">待收货</p>
						<p v-if="scope.row.status==3">已完成</p>
					</template>
				</el-table-column>
				<el-table-column prop="address" label="件数" align="center" width="150" :formatter="changeNull">
					<template slot-scope="scope">
						{{scope.row.goodsList.length}}
					</template>
				</el-table-column>
				<el-table-column prop="orderTotalPrice" label="订单总价(￥)" align="center" width="150" :formatter="changeNull">
				</el-table-column>
				<el-table-column prop="businessHours" label="订单类型" align="center" width="150" :formatter="changeNull">
					<template slot-scope="scope">
						<text v-if="scope.row.type==0">商城订单</text>
						<text v-if="scope.row.type==1">拼团订单</text>
						<text v-if="scope.row.type==66">活动订单</text>
					</template>
				
				</el-table-column>
				<el-table-column prop="rewardIntegralNumber" label="赠送流量池" align="center" width="150" :formatter="changeNull">
				</el-table-column>
				
			</el-table>
		
			<el-pagination background :current-page="orderData.pageNum" @current-change="pageWgChangeorder"
				layout="total, sizes, prev, pager,next" :total="orderData.total" @size-change="handleWgSizeChangeorder">
			</el-pagination>
			<span slot="footer" class="dialog-footer">
				<el-button @click="orderDialogVisible = false">返回</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
	import {
		uploadFileServer
	} from "@/api/axios.js";
	var urls = uploadFileServer('user');
	export default {
		data() {
			return {
				httpUrl: urls,
				xqDialogVisible: false,
				xqDialogVisible: false,
				tableLoading: false, //表格
				sureLoading: false, //充值
				inviteDataLoading: false, //邀请关系表格
				userList: [{}], //用户列表
				inviteDialogVisible: false,
				dialogVisible: false,
				editDialogVisible: false,
				integralId: "", //积分id
				userName:'',
				integralList: [],
				appropriation: "",
				ids: '', //授权用户id
				userData: [{}], //用户角色列表
				userDataList: [], //用户角色列表选中的
				formLabelWidth: "100px",
				form: {
					username: "",
					password: "",
					surePass: ""
				},
				mainFormRules: {
					username: {
						required: true,
						message: "请输入账号",
						trigger: "blur"
					},
					password: {
						required: true,
						message: "请输入密码",
						trigger: "blur"
					},
				},
				page: {
					pageNum: 1,
					pageSize: 10,
					invitePageNum: 1,
					invitePageSize: 10,

					WGPageNum: 1,
					WGPageSize: 10,
					qqPageSize:10,
					qqPageNum:1,
					storePageSize:10,
					storePageNum:1,
					orderPageSize:10,
					orderPageNum:1,
				},
				
				sjsum: 0,
				searchInfo: {
					isEnable: '',
					isSubscribe: '',
					orderType: 1
				},
				inviteData: [],
				setTLevelData: {
					agentLevel: "",
					provinceId: "",
					cityId: "",
					areaId: "",
					status: false,
					userId: "",
					id: "",
					data: [{
							name: ""
						},
						{
							name: ""
						},
						{
							name: ""
						}
					]
				},
				storeData:{},
				provinceId: '',
				cityId: '',
				areaId: '',
				provinceList: {}, //省
				cityList: {}, //市
				districtList: {}, //区
				userForm: {},
				logo: "",
				payUserName: '', //充值用户
				rechargeType: 1, //充值类型
				fileList: [], //充值图片
				goodsImages: [],
				cidImages: [],
				remark: '', //充值备注
				qqid:'',
				userId: '',
				qqData:{},
				sjsums: 0,
				userphone:'',
				storeRatio:[],
				userPropertyList: [],
				propertyDialogVisible: false,
				loadingUserProperty: false,

				//网体归属
				wtDialogVisible: false,
				qqDialogVisible: false,
				storeDialogVisible:false,
				orderDialogVisible:false,
				twData: {},
				orderData: {},
				wgid: '',
				sData: {},
				loadingTwo: false,
				loadingqq:false,
				loadingstore:false,
				loadingorder:false,
				gxInfo: {}
			};
		},
		filters: {
			fixedTwoWan(val) {
				let num = ""
				if (val >= 100000000) {
					num = Number(val / 1000000000).toFixed(2) + " Billion"
				} else if (val >= 10000) {
					num = Number(val / 10000).toFixed(2) + "万"
				} else {
					num = Number(val).toFixed(2)
				}
				return num
			},
			fixedTwo(val) {
				return Math.floor(Number(val))
			},
			fixedFour(val) {
				return Number(val).toFixed(4)
			}
		},
		computed: {
			zsum() {
				
				return Math.floor(this.sData.calculate * this.gxInfo.calculateRatio)+ Math.floor(this.gxsum) +
					Math.floor(this.qqsum) + Math.floor(this.xfsum)
			},
			xfsum() {
				return this.sData.shopAmount * this.gxInfo.shopAmountRatio + this.sData.teamShopAmount * this.gxInfo
					.teamShopAmountRatio
			},
			gxsum() {
				return this.sData.inviterCount * this.gxInfo.inviterRatio +
					this.sData.activateCount * this.gxInfo.activateRatio +
					this.sData.teamCount * this.gxInfo.teamRatio +
					this.sjsum
			},
			qqsum() {
				let sum = 0
				this.integralList.map(item => {
					sum += item.sum
				})
				return sum
			},
		},
		methods: {
			sums(e) {
			
				
				return this.storeRatio[e.levelType]
			},
			datails(it) {
				this.qqid=it.userId
				this.userName=it.username
				this.userphone=it.phone
				this.xqDialogVisible = true
				this.integralList = []
				this.$api.findkey('CONTRIBUTION_CONFIRMATION_PARAMETERS').then(res => {
					console.log(res.data, 1);
					this.gxInfo = JSON.parse(res.data.settingValue)
					this.storeRatio=JSON.parse(res.data.settingValue).storeRatio
					this.$api.contributionConfirmation(it.userId).then(res => {
						console.log(res.data, 2);
						this.sData = res.data
						let sums = 0
						let sum = 0
						res.data.storeCount.map(it => {

							sums += this.gxInfo.storeRatio[it.level] * it.count
							sum += it.count
						})
						this.sjsum = sums?sums:0
						this.sjsums = sum?sum:0
						console.log(this.sjsum,123456);
						this.$api.propertylist({
							userId: it.userId
						}).then(res => {

							// res.data=JSON.parse(this.$decrypt(res.data.data))
							res.data.map(item => {
								this.gxInfo.integral.map(items => {
									if (items.id == item.integralId) {
										this.integralList.push({
											sum: 0,
											total: item.inUseCnt,
											id: item.integralId,
											ratio: items.ratio,
											name: item.name,
											icon: item.icon
										})
									}
								})
							})
							this.sData.confirmationRightsCount.map(itemss => {
								this.integralList.map((itemsss, index) => {
									if (itemss.integralId == itemsss.id) {
										this.$set(this.integralList[index], 'sum',
											itemss.sum)
									}
								})
							})
							this.integralId = this.integralList[0].id
							this.integralInfo = this.integralList[0]
						})
					})

				})

			},
			toShowProperty(userId) {
				this.userPropertyList = []
				this.propertyDialogVisible = true
				this.loadingUserProperty = true;
				this.$api.getUserProperty({
					pageNum: 1,
					pageSize: 20,
					userId: userId
				}).then((res) => {
					res = JSON.parse(this.$decrypt(res.data))
					// console.log('资产列表---', res.data.data)
					if (res.state == 'success') {
						this.userPropertyList = res.data.data
					}
					this.loadingUserProperty = false;
				})

			},
			getOwnership() { //网体归属
				// console.log(this.page);
				this.loadingTwo = true;
				let data = {
					pageNum: this.page.WGPageNum,
					pageSize: this.page.WGPageSize,
					id: this.wgid
				}
				this.$api.ownership(data).then(res => {
					this.twData = res.data
					this.loadingTwo = false;
				})
			},
			getqqlist(){
				this.loadingqq = true;
				let data = {
					pageNum: this.page.qqPageNum,
					pageSize: this.page.qqPageSize,
					userId: this.qqid
				}
				this.$api.confirmationRightsList(data).then(res => {
					this.qqData = res.data
					this.loadingqq = false;
				})
			},
			getStoreList(){
				this.loadingstore = true;
				let data = {
					pageNum: this.page.storePageNum,
					pageSize: this.page.storePageSize,
					userId: this.qqid
				}
				this.$api.findStoreList(data).then(res => {
					this.storeData = res.data
					this.loadingstore = false;
				})
				
			},
			pageWgChangestore(data) { //
				// console.log(data);
				this.page.storePageNum = data
				this.getqqlist()
			},
			handleWgSizeChangestore(val) { //
				this.page.storePageSize = val
				this.getqqlist()
			},
			pageWgChangeorder(data) { //
				// console.log(data);
				this.page.orderPageNum = data
				this.getorderList()
			},
			handleWgSizeChangeorder(val) { //
				this.page.orderPageSize = val
				this.getorderList()
			},
			goorder(){
				this.orderDialogVisible=true
				this.getorderList()
			},
			getorderList(){
				this.loadingstore = true;
				let data = {
					pageNum: this.page.orderPageNum,
					pageSize: this.page.orderPageSize,
					userId: this.qqid
				}
				this.$api.storeOrderList(data).then(res => {
					this.orderData = res.data
					this.loadingorder = false;
				})
			},
			storeti(){
				
				this.storeDialogVisible=true
				this.getStoreList()
			},
			qqti(id){
				
				this.qqDialogVisible=true
				this.getqqlist()
			},
			wangti(id) { //网体归属
				this.wgid = id
				this.wtDialogVisible = true
				this.getOwnership()

			},
			pageWgChangeqq(data) { //
				// console.log(data);
				this.page.qqPageNum = data
				this.getqqlist()
			},
			handleWgSizeChangeqq(val) { //
				this.page.qqPageSize = val
				this.getqqlist()
			},
			pageWgChange(data) { //网体归属
				// console.log(data);
				this.page.WGPageNum = data
				this.getOwnership()
			},
			handleWgSizeChange(val) { //网体归属
				this.page.WGPageSize = val
				this.getOwnership()
			},

			handleRemove(file, fileList) {
				if (file.response) {
					this.goodsImages.remove(file.response.message);
				}
				// this.goodsImages.remove(file.url);
				this.fileList = this.fileList.filter(item => item.uid !== file.uid)
			},
			handlePictureCardPrediv(file) {
				this.dialogImageUrl = file.url;
				this.dialogVisibleImg = true;
			},
			onSuccess1(response, file) {
				console.log(response)
				this.goodsImages.push(response.message)
				this.fileList.push({
					"url": response.message
				})
				console.log("asda", this.fileList)
			},
			changeNull(row, column, cellValue) {
				if (cellValue) {
					return cellValue;
				} else if (cellValue == 0) {
					return "0";
				} else {
					return "暂无";
				}
			},
			empty() {
				this.searchInfo = {}
			},
			search() {
				this.page.pageNum = 1;
				this.getUserList()
			},
			findSysUserById(id) {
				this.$api.findSysUserById(id).then((res) => {
					if (res.state == 'success') {
						this.form.username = res.data.username
					}
				})
			},
			cannelPass() {
				this.editDialogVisible = false
			},
			//选择代理级别查询对用省市区数据
			chooseLevel(e) {
				if (e == 3 && this.cityId) {
					this.cityFcus(this.cityId)
				}
			},

			provinceFocus(e) { //查询市
				this.setTLevelData.areaId = null;
				this.provinceId = e;
				this.cityId = '';
				this.areaId = '';
				this.cityList = {}
				this.districtList = {}

				let obj = {};
				obj = this.provinceList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				});

				if (e) {
					this.$api.getAreasFive(e).then((res) => {
						if (res.state == 'success') {
							this.cityList = res.data
							console.log('查询市--', res.data)
						}
					})
				}
			},

			cityFcus(e) { //查询区
				this.setTLevelData.areaId = null;
				this.cityId = e;
				this.areaId = '';
				this.districtList = {}

				/* let obj = {};
				obj = this.cityList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				}); */

				if (e) {
					this.$api.getAreasFive(e).then((res) => {
						if (res.state == 'success') {
							this.districtList = res.data
							console.log('查询区--', res.data)
						}
					})
				}

			},
			districtFcus(e) {
				this.areaId = e;
				/*let obj = {};
				 obj = this.districtList.find((item) => { //这里的userList就是上面遍历的数据源
					return item.id === e; //筛选出匹配数据
				}); */
			},

			validateInput() {
				if (this.appropriation < 0) {
					// 输入的是负数，清空输入框的值
					this.appropriation = '';
				}
			},
			//提交充值
			sure() {
				this.sureLoading = true
				this.fileList.map(item => {
					console.log(item.url)
					this.cidImages.push(item.url)
				})
				let data = {
					userId: this.ids,
					integralId: this.integralId,
					amount: this.appropriation,
					rechargeMemo: this.remark,
					certificateImg: this.cidImages.join(','),
					type: this.rechargeType,
				}
				this.$api.getIntegralGly(data).then((res) => {
					if (res.state == 'success') {
						this.$message({
							message: res.message,
							type: 'success'
						});
						this.getUserList()
						this.dialogVisible = false;
					} else {
						this.$message.error(res.message);
					}
					this.sureLoading = false
				})
			},
			//删除
			toDelete(id) {
				this.$confirm('此操作将永久删除该信息, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.$api.deleteSysUser(id).then((res) => {
						if (res.state == 'success') {
							this.$message({
								message: res.message,
								type: 'success'
							});
							this.getUserList();
						} else {
							this.$message.error(res.message);
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			headClass() {
				return 'text-align:center;background:#E6E9F0;color: rgb(31, 46, 77);height:56px'
			},
			formartDate(row, column) {
				var ymdhis = "";
				if (row) {
					var time = new Date(row);
					ymdhis += time.getFullYear() + "-";
					ymdhis += ((time.getMonth() + 1) < 10 ? '0' + (time.getMonth() + 1) : (time.getMonth() + 1)) + "-";
					ymdhis += (time.getDate() < 10 ? '0' + time.getDate() : time.getDate()) + ' ';
					ymdhis += (time.getHours() < 10 ? '0' + time.getHours() : time.getHours()) + ":";
					ymdhis += (time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes()) + ":";
					ymdhis += (time.getSeconds() < 10 ? '0' + time.getSeconds() : time.getSeconds());
					return ymdhis;
				} else {
					return '无';
				}

			},
			pageChange(data) {
				this.page.pageNum = data
				this.getUserList()
			},
			handleSizeChange(val) {
				this.page.pageSize = val
				this.getUserList()
			},
			getUserList() {
				this.tableLoading = true
				let data = {
					pageNum: this.page.pageNum,
					pageSize: this.page.pageSize,
					startTime: this.searchInfo.timer ? this.searchInfo.timer[0] : "",
					endTime: this.searchInfo.timer ? this.searchInfo.timer[1] : "",
					username: this.searchInfo.username,
					userId: this.searchInfo.userId,
					phone: this.searchInfo.phone,

				}
				this.$api.usercontributionList(data).then((res) => { //会员列表
					if (res.state == 'success') {
						// console.log('表格数据--',res.data.list[0])
						this.userList = res.data
						this.tableLoading = false
					} else {
						this.$message({
							type: 'error',
							message: res.message
						});
					}
				})
			},
			toShowInvite(userId) {
				this.inviteData = []
				this.ids = userId
				this.inviteDialogVisible = true
				this.inviteDataLoading = false
				this.showInvite(userId);
			},
			pageInviteChange(data) {
				this.page.invitePageNum = data
				this.inviteDataLoading = false
				this.showInvite(this.ids)
			},
			handleInviteSizeChange(val) {
				this.page.invitePageSize = val
				this.inviteDataLoading = false
				this.showInvite(this.ids)
			},

			dialogTableLoad(tree, treeNode, resolve) {
				// console.log('参数---', tree)
				setTimeout(() => {
					const params = {
						//例如：需要传入的参数
						id: tree.id,
						pageNum: 1,
						pageSize: 20,
						// openId: tree.openId
					}
					this.$api.showInviteTwo(params).then(res => {
						// console.log('res.data.list---',res.data.list)
						// resolve(this.inviteData = res.data.list)
						resolve(res.data.list)
					})
				}, 1000)
			},
			showInvite(userId) {
				this.inviteDataLoading = true;
				let data = {
					id: this.ids,
					pageNum: this.page.invitePageNum,
					pageSize: this.page.invitePageSize,
				}
				this.$api.showInviteTwo(data).then((res) => {
					if (res.state == 'success') {
						// console.log('邀请下级---', res.data.list[0])
						this.inviteData = res.data
					} else {
						this.$message({
							type: 'error',
							message: res.message
						});
					}
					this.inviteDataLoading = false
				})
			},
		},
		created() {
			this.getUserList();



		}
	};
</script>

<style scoped>
	.demo-table-expand {
		font-size: 0;
		margin-left: 70px;
	}

	.demo-table-expand label {
		width: 100px;
		color: #99a9bf;
	}

	.demo-table-expand .el-form-item {
		margin-right: 0;
		margin-bottom: 0;
		width: 50%;
	}
	.textss{
		color: red;
		font-weight: 700;
	}
	.texts{
		color: #102ff7;
	}
</style>